export const last = <T = any>(arr: T[]) => {
  return arr[arr.length - 1];
};

export function intersection<T>(a: T[], b: T[]) {
  return a.filter((item) => b.includes(item));
}

export function removeItem<T>(arr: T[], target: T) {
  return arr.filter((item) => item !== target);
}

export function removeItems<T>(arr: T[], target: T[]) {
  return arr.filter((item) => !target.includes(item));
}

export function findItemByID<T extends { id: string; [key: string]: any }>(
  arr: T[] = [],
  id: string,
) {
  return arr?.find((item) => item?.id === id);
}

export function filterMap<V, D>(arr: V[], callback: (item: V) => D | false) {
  return arr.reduce((acc, item) => {
    const result = callback(item);
    if (!result) {
      return acc;
    }
    return [...acc, result];
  }, [] as D[]);
}
